// fish-web: Break the circular dep between app/router/index.js and shared services
// that import @/router. The original monorepo version eagerly imported ALL vertical
// routers at init time — that creates a TDZ cycle in fish-web.
//
// Solution: lazy proxy. The fish router is only accessed after full initialization,
// never during module evaluation. This lets webpack resolve the module graph without
// hitting the TDZ on app/router/index.js's default export.
//
// Vue reactive flags are handled explicitly to prevent toRaw() infinite recursion.

let _router = null

function getRouter() {
  if (!_router) {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    _router = require('@/fish/router').default
  }
  return _router
}

// Vue 3 reactive flags — returning these prevents Vue's toRaw() from recursing
const VUE_SKIP_FLAGS = new Set([
  '__v_skip',
  '__v_isReactive',
  '__v_isReadonly',
  '__v_isShallow',
  '__v_raw',
])

/** @type {import('vue-router').Router} */
const router = new Proxy(
  {},
  {
    get(_, prop) {
      // Tell Vue: this is not a reactive object — prevents toRaw() infinite recursion
      if (VUE_SKIP_FLAGS.has(prop)) {
        return undefined
      }
      return getRouter()[prop]
    },
    set(_, prop, value) {
      getRouter()[prop] = value
      return true
    },
  }
)

export default router
